import { atomWithStorage } from '@capsicum/common';

export const earnRewardsPointsAtom = atomWithStorage<boolean>('earnRewardsPoints', false);
